import { useEffect, useState } from "react";
import Card from "../../../components/ui/Card";
import Button from "../../../components/ui/Button";

import {
  getAdminBookings,
  updateBookingStatus,
} from "../../../api/bookings";

import {
  getAdminBookingOptions,
  createBookingOption,
  updateBookingOption,
  deleteBookingOption,
} from "../../../api/bookingOptions";

import { MdPhone, MdAccessTime, MdDelete } from "react-icons/md";

const STATUS_COLORS = {
  New: "bg-yellow-100 text-yellow-800",
  Confirmed: "bg-blue-100 text-blue-800",
  Cancelled: "bg-red-100 text-red-800",
  Completed: "bg-green-100 text-green-800",
};

const Bookings = () => {

  const [bookings, setBookings] = useState([]);
  const [options, setOptions] = useState([]);

  const [newOption, setNewOption] = useState({
    title: "",
    type: "Doctor",
  });

  const [loading, setLoading] = useState(false);


  const load = async () => {
    setLoading(true);

    const [b, o] = await Promise.all([
      getAdminBookings(),
      getAdminBookingOptions(),
    ]);

    setBookings(b.data || []);
    setOptions(o.data || []);

    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);


  const changeStatus = async (id, status) => {
    await updateBookingStatus(id, status);
    load();
  };

  const addOption = async () => {
    if (!newOption.title) return;

    await createBookingOption({
      title: newOption.title,
      type: newOption.type,
      sortOrder: 0,
    });

    setNewOption({ title: "", type: "Doctor" });
    load();
  };

  const toggleActive = async (o) => {
    await updateBookingOption(o.id, {
      title: o.title,
      isActive: !o.isActive,
      sortOrder: o.sortOrder,
    });

    load();
  };

  const removeOption = async (id) => {
    await deleteBookingOption(id);
    load();
  };


  return (
    <div className="space-y-6">


      <Card title="Doctors / Services">
        <div className="flex gap-3 mb-4 flex-wrap">
          <input
            className="border rounded-lg px-3 py-2"
            placeholder="Title"
            value={newOption.title}
            onChange={(e) =>
              setNewOption((s) => ({
                ...s,
                title: e.target.value,
              }))
            }
          />

          <select
            className="border rounded-lg px-3 py-2"
            value={newOption.type}
            onChange={(e) =>
              setNewOption((s) => ({
                ...s,
                type: e.target.value,
              }))
            }
          >
            <option value="Doctor">Doctor</option>
            <option value="Service">Service</option>
          </select>

          <Button onClick={addOption}>Add</Button>
        </div>

        {options.map((o) => (
          <div
            key={o.id}
            className="flex items-center justify-between border rounded-lg p-3 mb-2"
          >
            <div>
              <b>{o.title}</b>{" "}
              <span className="text-xs text-gray-500">
                ({o.type})
              </span>
            </div>

            <div className="flex gap-2">
              <Button
                variant="outline"
                onClick={() => toggleActive(o)}
              >
                {o.isActive ? "Deactivate" : "Activate"}
              </Button>

              <button
                onClick={() => removeOption(o.id)}
                className="text-red-500 hover:text-red-700"
              >
                <MdDelete />
              </button>
            </div>
          </div>
        ))}
      </Card>

      <Card title="Bookings">
        {loading && "Loading..."}

        {!loading && bookings.length === 0 && (
          <p className="text-sm text-gray-500">
            No bookings yet.
          </p>
        )}

        {bookings.map((b) => (
          <div
            key={b.id}
            className="border rounded-xl p-4 mb-4 space-y-3"
          >
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-semibold text-lg text-[#28424d]">
                  {b.name}
                </h3>

                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <MdPhone />
                  {b.phone}
                </div>
              </div>

              <span
                className={`px-3 py-1 rounded-full text-xs font-medium ${
                  STATUS_COLORS[b.status]
                }`}
              >
                {b.status}
              </span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
              <div>
                <b>Type:</b> {b.bookingOptionType}
              </div>

              <div>
                <b>Doctor / Service:</b>{" "}
                {b.bookingOptionTitle}
              </div>

              <div className="flex items-center gap-1">
                <MdAccessTime />
                {new Date(b.preferredAtUtc).toLocaleString()}
              </div>
            </div>

            {b.message && (
              <p className="text-sm">
                <b>Message:</b> {b.message}
              </p>
            )}

            <div className="flex gap-2 flex-wrap">
              {["New", "Confirmed", "Completed", "Cancelled"]
                .filter((s) => s !== b.status)
                .map((s) => (
                  <Button
                    key={s}
                    variant="outline"
                    onClick={() =>
                      changeStatus(b.id, s)
                    }
                  >
                    Mark {s}
                  </Button>
                ))}
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
};

export default Bookings;
